/**
 * Cookieless pageview tracker.
 *
 * Mounts once at the app root. Sends one POST per route change to
 * /api/track/pageview. Fire-and-forget — never blocks navigation.
 *
 * GDPR: no cookies, no persistent ID, no PII. Backend stores only a
 * daily-rotating opaque hash. Therefore safe to track without samtykke
 * (Article 6(1)(f) — legitimate interest in aggregated audience stats).
 */
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { apiOrigin } from "../lib/apiBase";

export default function PageviewTracker() {
    const location = useLocation();
    const lastPathRef = useRef("");

    useEffect(() => {
        const path = location.pathname + (location.search || "");
        if (path === lastPathRef.current) return;
        lastPathRef.current = path;

        // Fire-and-forget. We use keepalive so it survives a tab close.
        try {
            fetch(`${apiOrigin}/api/track/pageview`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    path,
                    referrer: document.referrer || null,
                }),
                keepalive: true,
            }).catch(() => {
                /* swallow — never break UX over a tracking failure */
            });
        } catch (e) {
            console.warn("pageview-tracker: fetch threw", e);
        }
    }, [location.pathname, location.search]);

    return null;
}
